import React from "react";
import Login from "view/Authentication/Forms/Login";
import Signup from "view/Authentication/Forms/Signup";
import Forgot from "view/Authentication/Forms/Forgot";
import Change from "view/Authentication/Forms/Change";
import LayoutAuthentication from "components/Layout/LayoutAuthentication";
import { useParams } from "react-router-dom";

export default function PageAuthentication({ ...props }) {
    const { uuid } = useParams();

    const Render = ({ ...renderProps }) => {
        if (renderProps.path === 'login') {
            return <Login />;
        }

        if (renderProps.path === 'signup') {
            return <Signup />;
        }

        if (renderProps.path === 'forgot') {
            if (uuid) {
                // With UUID to change password
                return <Change uuid={uuid} />;
            }

            // Default layout for forgot password
            return <Forgot />;
        }

        /*
         * Fallback.
         *
         * Nunca podemos dejar que Render termine sin devolver
         * un componente, porque React lanzaría:
         *
         * "Nothing was returned from render"
         *
         * Si por cualquier motivo no recibimos un path válido,
         * mostramos el formulario de login.
         */
        return <Login />;
    };

    return (
        <LayoutAuthentication {...props}>
            <Render {...props} />
        </LayoutAuthentication>
    );
}